import type { FuncOverrideComponent } from '../theme.types';
import '../fontFaces';

export const MuiCssBaseline: FuncOverrideComponent<'MuiCssBaseline'> = () => ({
  styleOverrides: {},
});
